import { store } from '../store';
import { setErrorMessage } from '../store/errorSlice';

/**
 * Simple error handler that logs to console and dispatches error message
 * @param error - The error object or message to log
 * @param userMessage - User-friendly error message to display
 */
export const handleError = (
  error: any,
  userMessage: string
): void => {
  console.error('Error:', error);
  store.dispatch(setErrorMessage(userMessage));
};
